import { z } from 'zod';

import { commissionSchema } from '../../commission/schemas/commission';
import { invoiceSchema } from '../../invoice/schemas/invoice';
import { userSchema } from '../../user/types';
import { attachmentSchema } from './attachment';

export const extendedAttachmentSchema = attachmentSchema.extend({
    commission: commissionSchema.nullish(),
    invoice: invoiceSchema.nullish(),
    uploadedBy: userSchema.nullish(),
});
export type TExtendedAttachment = z.infer<typeof extendedAttachmentSchema>;
